import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { GetApi } from '../../../js_assets/Network';
import { getParameterByName } from '../../../js_assets/getParameterByName'
import Grid from '@material-ui/core/Grid';

import AppAdminContainer from '../AppAdminContainer'

import AgGridTable from '../../agGridTable'



const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 8,
        margin: 12

    },
    divider: {
        width: '100%',
    },
    ButtonSearch: {
        backgroundColor: '#007bff',
        color: 'white',
        '&:hover': {
            background: '#007bff'
        }
    },
    ButtonLocation: {
        backgroundColor: '#4CAF50',
        color: 'white',
        '&:hover': {
            background: '#4CAF50'
        }
    },
    ButtonGuide: {
        backgroundColor: '#74cbc4',
        color: 'white',
        '&:hover': {
            background: '#74cbc4'
        },
        margin: theme.spacing.unit,
        padding: '2px'
    },
    tab: {
        flexGrow: 1,
        marginTop: 2,
        backgroundColor: '#f7faea'

    },
    iocns: {
        fontSize: 18
    }


});

class AdminStoreSaleReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sale_data_Monthly: {},
            sale_data_Weekly: {},
            sale_data: [],
            loading_state_iocn: true,
            Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
            columnDefs: [],
            rowData: []

        };
    }

    componentDidMount() {


        const { Admin_Info } = this.state;


        let store_Id = getParameterByName("store_Id")


        if (store_Id !== null) {


            if (store_Id === "all") {

                Promise.all([
                    GetApi(`/api/Order/AllStoreSaleReport/${Admin_Info.admin_Id}`, Admin_Info.jwT_Token_Admin),

                ]).then(rep => {

                    this.setState({ sale_data: rep[0], loading_state_iocn: false })

                    this.init_columnDefs();

                })

            } else {
                Promise.all([
                    GetApi(`/api/Order/StoreSaleReport/${Admin_Info.admin_Id}/${store_Id}`, Admin_Info.jwT_Token_Admin),

                ]).then(rep => {

                    this.setState({ sale_data: rep[0], loading_state_iocn: false })

                    this.init_columnDefs();

                })

            }





        }







    }


    init_columnDefs = () => {


        const { sale_data } = this.state

        //console.log(sale_data)

        let columnDefs = [
            { headerName: " المتجر", field: "store_Name" },
            { headerName: "رقم الطلب", field: "order_Number" },
            { headerName: "المدنية", field: "city_Name" },
            { headerName: "نوع الدفع", field: "payment_Type_Name" },
            { headerName: "اجمالي الطلب", field: "order_Total_Amount" },
            { headerName: "اجمالي  قبل الخصم", field: "order_Total_Amount_Before_Discount" },
            { headerName: "تاريخ الطلب", field: "order_Date" },
            { headerName: "سعر التوصيل", field: "delivery_Price" },
            { headerName: "رقم ميسر", field: "payment_Transaction_Id" },
            { headerName: "الاسم", field: "userName" },
            { headerName: "رقم الجوال", field: "user_Phone" },
            { headerName: "الايميل", field: "user_Email" },


        ]



        this.setState({ columnDefs: columnDefs, rowData: sale_data })

    }






    render() {
        const { classes } = this.props;
        const { sale_data_Monthly, sale_data_Weekly, loading_state_iocn, columnDefs, rowData } = this.state;

        return (

            <AppAdminContainer Title={"التقرير المالي"} >


                <div className="container">

                    <Grid justify="center" alignItems="center" container spacing={8}>
                        <h3 className="containerOfferh4" >  التقرير الشهري  </h3>
                    </Grid>
                    <br></br>
                    <Grid justify="center" alignItems="center" container spacing={8}  >
                        <AgGridTable columnDefs={columnDefs} rowData={rowData} />
                    </Grid>



                </div>




            </AppAdminContainer >




        )
    }


}
AdminStoreSaleReport.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminStoreSaleReport);